import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import withStyles from '@mui/styles/withStyles';
import EnhancedTableHead from 'components/Shared/EnhancedTableHead';
import ReclamationRow from './ReclamationRow';
import ReclamationsTableFooter from './ReclamationsTableFooter';

import Paper from '@mui/material/Paper';

const styles = {
    table: {
        minWidth: 700,
        maxWidth: '100%',
        background: 'white'
    }
};

const columnData = [
    { id: 'observateur', numeric: false, disablePadding: true, label: '' },
    { id: 'affectation', numeric: false, disablePadding: true, label: '' },
    { id: 'prioritaire', numeric: false, disablePadding: true, label: '' },
    { id: 'commentaires', numeric: false, disablePadding: true, label: '' },
    { id: 'dateVerification', numeric: false, disablePadding: false, label: '' },
    { id: 'id', numeric: true, disablePadding: true, label: 'Dossier', tri: 'entier' },
    { id: 'numeroPiece', numeric: false, disablePadding: false, label: 'Pièce', tri: 'chaine' },
    { id: 'numeroPreparation', numeric: false, disablePadding: false, label: 'Préparation', tri: 'chaine' },
    { id: 'depotDepart', numeric: false, disablePadding: false, label: 'Dépôt de départ', tri: '' },
    { id: 'dateCreation', numeric: false, disablePadding: false, label: 'Date', tri: 'chaine' },
    { id: 'client', numeric: false, disablePadding: false, label: 'Client', tri: 'special' },
    { id: 'emetteur', numeric: false, disablePadding: false, label: 'Émetteur', tri: 'special' },
    { id: 'groupe', numeric: false, disablePadding: false, label: 'Groupe', tri: 'special' },
    { id: 'utilisateur', numeric: false, disablePadding: false, label: 'Utilisateur', tri: 'special' },
    { id: 'statut', numeric: false, disablePadding: false, label: 'Statut', tri: 'entier' },
    { id: 'transporteurNom', numeric: false, disablePadding: false, label: 'Transporteur', tri: 'chaine' },
    { id: 'departement', numeric: true, disablePadding: false, label: 'Département', tri: 'entier' }
];

class ReclamationsTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            order: 'desc',
            orderBy: ''
        };
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        let data = this.props.items;

        let column = columnData.find(x => x.id === orderBy);
        if (column === undefined || column.tri === undefined) {
            this.setState({ data, order, orderBy });
            return;
        }

        // Traitement des cas spéciaux
        if (orderBy === 'client') {
            data =
                order === 'desc'
                ? this.props.items.sort((a, b) => (a[orderBy].code === null && b[orderBy].code === null ? 0 : a[orderBy].code === null ? 1 : b[orderBy].code === null ? -1 : a[orderBy].code.localeCompare(b[orderBy].code)))
                : this.props.items.sort((a, b) => (a[orderBy].code === null && b[orderBy].code === null ? 0 : a[orderBy].code === null ? 1 : b[orderBy].code === null ? -1 : b[orderBy].code.localeCompare(a[orderBy].code)));
        }

        if (orderBy === 'emetteur' || orderBy === 'utilisateur') {
            data =
                order === 'desc'
                    ? this.props.items.sort((a, b) => (a[orderBy].codePO === null && b[orderBy].codePO === null ? 0 : a[orderBy].codePO === null ? 1 : b[orderBy].codePO === null ? -1 : a[orderBy].codePO.localeCompare(b[orderBy].codePO)))
                    : this.props.items.sort((a, b) => (a[orderBy].codePO === null && b[orderBy].codePO === null ? 0 : a[orderBy].codePO === null ? 1 : b[orderBy].codePO === null ? -1 : b[orderBy].codePO.localeCompare(a[orderBy].codePO)));
        }

        if (orderBy === 'groupe') {
            data =
                order === 'desc'
                    ? this.props.items.sort((a, b) => (a[orderBy].libelle === null && b[orderBy].libelle === null ? 0 : a[orderBy].libelle === null ? 1 : b[orderBy].libelle === null ? -1 : a[orderBy].libelle.localeCompare(b[orderBy].libelle)))
                    : this.props.items.sort((a, b) => (a[orderBy].libelle === null && b[orderBy].libelle === null ? 0 : a[orderBy].libelle === null ? 1 : b[orderBy].libelle === null ? -1 : b[orderBy].libelle.localeCompare(a[orderBy].libelle)));
        }

        // Traitement des cas dépendant du type de données
        if (column.tri === 'chaine') {
            data =
                order === 'desc'
                    ? this.props.items.sort((a, b) => (a[orderBy] === null && b[orderBy] === null ? 0 : a[orderBy] === null ? 1 : b[orderBy] === null ? -1 : a[orderBy].localeCompare(b[orderBy])))
                    : this.props.items.sort((a, b) => (a[orderBy] === null && b[orderBy] === null ? 0 : a[orderBy] === null ? 1 : b[orderBy] === null ? -1 : b[orderBy].localeCompare(a[orderBy])));

        }
        if (column.tri === 'entier') {
            data =
                order === 'desc'
                    ? this.props.items.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                    : this.props.items.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
        }

        this.setState({ data, order, orderBy });
    };

    getItemsIds(items) {
        return items.map(x => x.id);
    }

    render() {
        const { items, classes, isPaging } = this.props;
        const { data, order, orderBy } = this.state;

        let list = items;
        if (data && items.length === data.length)
            list = data;

        return (
            <Paper elevation={1}>
                <Table className={classes.table}>
                    {items.length > 0 && (
                        <EnhancedTableHead
                            columnData={columnData}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={items.length}
                            showSelectColumn={false}
                            stickyHeader={72}
                        />
                    )}

                    <TableBody>
                        {this.getItemsIds(list).map(n => <ReclamationRow key={n} reclamationId={n} />)}
                    </TableBody>

                    <ReclamationsTableFooter isLoading={isPaging} hasReclamations={items.length > 0} />
                </Table>
            </Paper>
        );
    }
}

ReclamationsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    isPaging: PropTypes.bool.isRequired
};

export default withStyles(styles)(ReclamationsTable);